export default theme => ({
    root: {
        fontWeight: 500,
        padding: theme.spacing(1, 3),
        whiteSpace: 'nowrap',
        height: theme.spacing(8),
        opacity: 1,
    },
    wrapper: {
        alignItems: 'stretch',
    },
    textColorInherit: {
        color: theme.palette.grey[600],
        '&:hover': {
            color: theme.palette.secondary.main,
        },
        '&.Mui-selected': {
            padding: theme.spacing(1, 3, 0.4),
            color: theme.palette.secondary.main,
            borderBottom: `${theme.spacing(0.6)} solid ${theme.palette.secondary.main}`,
        },
    },
});
